import { withStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { joinToPublicGroup } from '../../../groups/groupUtils';
import CollectionsCard from './CollectionsCard';
import List from './List';

const styles = theme => ({
    groupsContainer: {
        marginTop: -32,
        height: 'calc(686px - 48px)',
        paddingTop: 48,
        backgroundColor: theme.customColors.primary.b500,
        width: '100%',
    },
})
//theme.customColors.primary.b500
const getMaxUsersLengthInCollection = (allCollection = []) => {
    return Math.max(...allCollection.map(collection => collection.collectionGroup.groupUsers.length))
}
const CollectionsCards = (props) => {
    const { classes, allCollections} = props;
    const maxUsersLengthInCollection = getMaxUsersLengthInCollection(allCollections)
    const [isLoading, setIsLoading] = useState(false)

    const join = (collection, goToCollection) => {
        if(isLoading) return
        const { searchQuery, dispatch, queryService, groupService, userSettingsService } = props;
        const { groupUid } = collection.collectionGroup
        setIsLoading(true)
        joinToPublicGroup(groupUid, searchQuery, dispatch, queryService, groupService, userSettingsService, () => {
            dispatch({ type: 'DATA_UPDATE' });
            setIsLoading(false);
            goToCollection();
        })
    }

    return allCollections && allCollections.length &&
        <div data-intrcm-id="CollectionsCards_1ung8m6c" className={classes.groupsContainer}>
            <List>
                {allCollections.sort((a,b)=>(a.title > b.title) - (a.title < b.title)).map((collection, idx) => <CollectionsCard join={join} maxUsersLength={maxUsersLengthInCollection} collection={collection} key={idx} />)}
            </List>
        </div>
}

const mapStateToProps = (state) => ({
    profileData: state.userData.profileData,
    groupService: state.services.groupService,
    userSettingsService: state.services.userSettingsService,
    queryService: state.services.queryService,
    searchQuery: state.search
})

const mapDispatchToProps = dispatch => ({
    dispatch,
})

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(CollectionsCards);

